import { useState } from "react";

function Planet({ planet }) {
  const [overview, setOverview] = useState(true);
  const [internal, setInternal] = useState(false);
  const [geology, setGeology] = useState(false);
  const [style, setStyle] = useState("");

  function handleOverview() {
    const newStyle = {
      backgroundColor: planet.color,
      borderBottom: `1px solid ${planet.color}`,
    };
    setStyle(newStyle);
    setOverview(true);
    setInternal(false);
    setGeology(false);
  }

  function handleInternal() {
    setInternal(true);
    setOverview(false);
    setGeology(false);
  }

  function handleGeology() {
    setGeology(true);
    setOverview(false);
    setInternal(false);
  }

  return (
    <>
      <div className="planet-details">
        {/* start - Conditional showing images */}
        {overview && (
          <div className="planet-img-box">
            <img src={planet.images.planet} alt="mercury planet" />
          </div>
        )}
        {internal && (
          <div className="planet-img-box">
            <img src={planet.images.internal} alt="mercury planet" />
          </div>
        )}
        {geology && (
          <div className="planet-img-box geology-box">
            <img src={planet.images.planet} alt="mercury planet" />
            <img
              className="secondary-img"
              src={planet.images.geology}
              alt="mercury planet"
            />
          </div>
        )}
        {/* end - Conditional showing images */}
        <div className="planet-desc">
          {/* Planet desc box */}
          <div className="planet-desc-box">
            <h1 className="planet-name">{planet.name}</h1>
            {overview && (
              <p className="planet-text">{planet.overview.content}</p>
            )}
            {internal && (
              <p className="planet-text">{planet.structure.content}</p>
            )}
            {geology && <p className="planet-text">{planet.geology.content}</p>}

            {overview && (
              <p className="wiki-link">
                Source :&nbsp;
                <a href={`${planet.overview.source}`}>Wikipedia</a>
              </p>
            )}
            {internal && (
              <p className="wiki-link">
                Source :&nbsp;
                <a href={`${planet.structure.source}`}>Wikipedia</a>
              </p>
            )}
            {geology && (
              <p className="wiki-link">
                Source :&nbsp;
                <a href={`${planet.geology.source}`}>Wikipedia</a>
              </p>
            )}
          </div>
          {/* Planet tabs */}
          <div className="planet-tabs">
            <button
              className={`planet-tab ${overview ? "planet-tab-active" : ""}`}
              onClick={handleOverview}
              style={{ style }}
            >
              <span className="planet-tab-title">01</span>
              Overview
            </button>
            <button
              className={`planet-tab ${internal ? "planet-tab-active" : ""}`}
              onClick={handleInternal}
              style={{ style }}
            >
              <span className="planet-tab-title">02</span>
              <span className="mobile-view">Internal</span> Structure
            </button>
            <button
              className={`planet-tab ${geology ? "planet-tab-active" : ""}`}
              onClick={handleGeology}
              style={{ style }}
            >
              <span className="planet-tab-title">03</span>
              Surface <span className="mobile-view">Geology</span>
            </button>
          </div>
        </div>
      </div>
      <div className="planet-in-numbers">
        <div className="planet-fact">
          <h4>Rotation time</h4>
          <p>{planet.rotation}</p>
        </div>
        <div className="planet-fact">
          <h4>Revolution time</h4>
          <p>{planet.revolution}</p>
        </div>
        <div className="planet-fact">
          <h4>Radius</h4>
          <p>{planet.radius}</p>
        </div>
        <div className="planet-fact">
          <h4>Average temp.</h4>
          <p>{planet.temperature}</p>
        </div>
      </div>
    </>
  );
}

export default Planet;
